import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MinaSidorElavtal = lazy(() => import("@/pages/mina-sidor/Elavtal"));

export const Route = createFileRoute("/mina-sidor/elavtal")({
  component: () => <MinaSidorElavtal />,
});
